<template>
  <div class="markdown-body" v-html="sanitizedHtml"></div>
</template>

<script>
import { marked } from 'marked'
import DOMPurify from 'dompurify'
import katex from 'katex'
import 'katex/dist/katex.min.css'

export default {
  name: 'MarkdownViewer',
  props: {
    content: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      sanitizedHtml: ''
    }
  },
  watch: {
    content: {
      immediate: true,
      handler(val) {
        this.render(val || '')
      }
    }
  },
  methods: {
    render(src) {
      try {
        // Replace math blocks first ($$...$$)
        let textWithMath = (src || '').replace(/\$\$([\s\S]+?)\$\$/g, (m, expr) => {
          try {
            return katex.renderToString(expr, { displayMode: true, throwOnError: false })
          } catch (_) { return m }
        })
        // Replace inline math ($...$) - simple safe regex (no newlines)
        textWithMath = textWithMath.replace(/\$([^$\n]+?)\$/g, (m, expr) => {
          try {
            return katex.renderToString(expr, { displayMode: false, throwOnError: false })
          } catch (_) { return m }
        })

        // Configure marked
        marked.setOptions({
          breaks: true,
          gfm: true,
          mangle: false,
          headerIds: true
        })

        const html = marked.parse(textWithMath)
        this.sanitizedHtml = DOMPurify.sanitize(html)
      } catch (e) {
        this.sanitizedHtml = DOMPurify.sanitize((src || '').replace(/\n/g, '<br/>'))
      }
    }
  }
}
</script>

<style scoped>
.markdown-body {
  font-size: 14px;
  line-height: 1.7;
  color: #303133;
}
.markdown-body h1, .markdown-body h2, .markdown-body h3 {
  margin: 12px 0 8px;
  font-weight: 600;
}
.markdown-body p { margin: 6px 0; }
.markdown-body code { background: #f6f8fa; padding: 2px 4px; border-radius: 3px; }
.markdown-body pre { background: #f6f8fa; padding: 8px; border-radius: 4px; overflow: auto; }
.markdown-body blockquote { border-left: 4px solid #dfe2e5; padding: 0 12px; color: #6a737d; margin: 8px 0; }
</style>

